<div [style]="'height: calc(99vh - ' + (layoutService.headerFooterHeight$ | async) + 'px)'">
  @if (staffMenu) {
    <div fxLayout="column" fxLayoutAlign="start stretch" style="height: 100%">
      <ag-staff-navigation id="staffNav" [staffMenu]="staffMenu"></ag-staff-navigation>
      @if (!pageLoaded) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      <ag-iframe
        #iframe
        fxFlex
        id="i-frame"
        [url]="url"
        [menuItem]="staffMenu?.menuItem"
        [printStatus]="printStatus"
        (onloaded)="pageLoaded = $event"
      ></ag-iframe>
    </div>
  }
</div>
